module.exports = __webpack_public_path__ + "static/team-1-76b3274a3c985a67c2f835fc398e1852.png";